import { render } from "./ConfirmRecoverVideoModal.vue?vue&type=template&id=2135fd72&scoped=true"
import script from "./ConfirmRecoverVideoModal.vue?vue&type=script&lang=js"
export * from "./ConfirmRecoverVideoModal.vue?vue&type=script&lang=js"

import "./ConfirmRecoverVideoModal.vue?vue&type=style&index=0&id=2135fd72&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2135fd72"]])

export default __exports__